<template>
  <div class="flex flex-col justify-center items-center break-words bg-shade-white">
    <div
      v-for="{ key, value } in authStoreFormatted"
      :key="key"
      class="text-pretty w-3/5 flex flex-col p-4"
    >
      <BodyText
        size="large"
        class="font-bold"
      >
        {{ key }}:
      </BodyText>
      <BodyText>
        {{ value }}
      </BodyText>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { useAuthStore } from '@shared/stores/auth'

const BodyText = defineAsyncComponent(() => import('@shared/design-system/components/Typography/BodyText.vue'))

const authStore = useAuthStore()

const authStoreFormatted = computed<{ key: string, value: unknown }[]>(() => {
  return Object.entries(authStore).map(([key, value]) => {
    if (typeof value !== 'function' && !key.startsWith('$') && !key.startsWith('_')) {
      return { key, value }
    }
  }).filter(entry => entry !== undefined).sort((key1, key2) => {
      if (key2 < key1) {
        return -1
      }
      if (key2 > key1) {
        return 1
      }
      return 0
  })
})
</script>